import * as React from "react";
import styled from "@emotion/styled";
import Modal from "react-bootstrap/Modal";
import { useFilestack } from "./useFilestack";
import { Close } from "../../icons";
import { MediaUploadModalProps, containerIds } from "./filestackConfig";

export const MediaUploadModal: React.FC<MediaUploadModalProps> = (
  props: MediaUploadModalProps
) => {
  const {
    showModal,
    onHide,
    apiKey,
    onUploadDone,
    onUploadFailed,
    storageOptions,
    mediaType,
  } = props;

  const modalId = containerIds[mediaType];

  const { openPicker } = useFilestack({
    apiKey,
    onUploadDone,
    onUploadFailed,
    mediaType,
    storageOptions,
    onHide,
  });

  React.useEffect(() => {
    if (showModal) {
      openPicker();
    }
  }, [showModal]);

  return (
    <Modal
      centered
      show={showModal}
      contentClassName="media-upload-modal-content"
      onHide={onHide}
      dialogClassName="media-upload-modal-dialog"
    >
      <Wrapper>
        <FilestackContainer id={modalId} data-testid={modalId} />
        <CloseButton
          data-testid="media-upload-close-button"
          onClick={() => onHide()}
        >
          <Close />
        </CloseButton>
      </Wrapper>
    </Modal>
  );
};

const FilestackContainer = styled.div({
  height: "100%",
  width: "100%",
  position: "absolute",
  zIndex: 3,
});

const CloseButton = styled.span({
  position: "absolute",
  top: 10,
  right: 15,
  cursor: "pointer",
  zIndex: 4,
});

const Wrapper = styled.div({ position: "relative", height: "25rem" });
